import React, { useCallback } from 'react';
import StyledButton from '../../../../../shared/components/styledButton/styledButton';
import { Alert, Snackbar } from '@mui/material';
//REDUX
import { useSelector } from 'react-redux';
import { providerCompanyIndustryList } from '../../../../data/providerText';
import ExperienceInput from './inputs/experienceInput';
import i18n from '../../../../../utils/i18n';

const IndustryExperience = ({ submitToDB }) => {
  const [edit, setEdit] = React.useState(false);
  const [modified, setModified] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const [providerIndustryRestrictions, providerIndustryExperience] =
    useSelector((state) => [
      state.provider_industry_restrictions,
      state.provider_industry_experience,
    ]);
  const checkModified = (modified) => {
    setModified(modified);
  };

  const industryCheck = () => {
    let industryShown = [];
    providerCompanyIndustryList().forEach((item, i) => {
      let filteredArr = providerIndustryRestrictions.filter((ind) => ind.on);
      filteredArr.forEach((filtereditem) => {
        if (filtereditem.id === item.id) {
          industryShown.push(
            <p key={i}>
              {item.label}{' '}
              <span>{`${providerIndustryExperience[item.id]} / 5`}</span>
            </p>
          );
        }
      });
    });
    return industryShown;
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  return (
    <div className='PublicProfile'>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        style={{ width: '50%' }}
      >
        <Alert onClose={handleClose} severity='success' className='AlertWidth'>
          {i18n.t('general.savedmessage')}
        </Alert>
      </Snackbar>
      <div className='IndustryExperience'>
        {edit ? (
          <>
            <ExperienceInput checkModified={checkModified} />
          </>
        ) : (
          <>{industryCheck()}</>
        )}
        <StyledButton
          onClick={() => {
            setEdit(!edit);
            if (edit && modified) {
              submitToDB({
                provider_industry_experience: providerIndustryExperience,
              });
              setModified(false);
              setOpen(true);
            }
          }}
          color={'Primary'}
        >
          {edit
            ? modified
              ? i18n.t('general.save')
              : i18n.t('general.backbutton')
            : i18n.t('general.modify')}
        </StyledButton>
      </div>
    </div>
  );
};

export default IndustryExperience;
